// Claude: Seller Feedback admin page 26-03-2026
import React from "react";
import FeedbackPage from "./FeedbackPage";

const SellerFeedback = () => <FeedbackPage role="Seller" title="Seller Feedback" />;
export default SellerFeedback;
